import { useCallback } from 'react';
import { useAuthContext } from '@hooks/useAuthContext';
import { firestore } from '@/utils';
import { collection, doc, updateDoc, writeBatch } from 'firebase/firestore';

export const useUserNotificationUpdateStatus = () => {
  const { user } = useAuthContext();

  const markAsRead = useCallback(
    async (id: string) => {
      if (!firestore) {
        throw new Error('Firestore is not initialized');
      }
      const base = collection(firestore, 'users');
      const usersRef = doc(base, `${user?.id}`);
      const notificationsRef = collection(usersRef, 'notifications');
      const notificationItem = doc(notificationsRef, id);
      const response = await updateDoc(notificationItem, {
        read: true,
      });
      return response;
    },
    [user?.id]
  );

  const markAllAsRead = useCallback(
    async (ids: string[]) => {
      if (!firestore) {
        throw new Error('Firestore is not initialized');
      }
      const base = collection(firestore, 'users');
      const usersRef = doc(base, `${user?.id}`);
      const notificationsRef = collection(usersRef, 'notifications');
      const batch = writeBatch(firestore);
      ids.forEach((id) => {
        const notificationItem = doc(notificationsRef, id);
        batch.update(notificationItem, {
          read: true,
        });
      });
      const response = await batch.commit();
      return response;
    },
    [user?.id]
  );

  const markAsUnread = useCallback(
    async (id: string) => {
      if (!firestore) {
        throw new Error('Firestore is not initialized');
      }
      const base = collection(firestore, 'users');
      const usersRef = doc(base, `${user?.id}`);
      const notificationsRef = collection(usersRef, 'notifications');
      const notificationItem = doc(notificationsRef, id);
      const response = await updateDoc(notificationItem, {
        read: false,
      });
      return response;
    },
    [user?.id]
  );

  return {
    markAsRead,
    markAllAsRead,
    markAsUnread,
  };
};
